import isEqualWith from 'lodash/isEqualWith'

export const isEqualExcludeFunctions = (a: any, b: any) =>
  isEqualWith(a, b, (a, b) => {
    if (typeof a === 'function' || typeof b === 'function') return true
  })
